export default "__VITE_ASSET__DtdXcx3I__"